import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const YoutubeVideo = lazy(() => import(/* webpackChunkName: "YoutubeVideo" */ './components/YoutubeVideo'));

const youtubeVideos = document.querySelectorAll('[data-youtube-video]');
if (youtubeVideos != null) {
    youtubeVideos.forEach((youtubeVideo, index) => {
        const props = parseDatasetToProps(youtubeVideo.dataset);

        render(
            <Suspense fallback={<></>}>
                <YoutubeVideo
                    key={index}
                    {...props}
                />
            </Suspense>,
            youtubeVideo
        );
    });
}
